import { AppState } from 'src';
import {
  ContractErrorSearchComponentProperties,
  ContractErrorSearchComponent
} from './contract-error-search.component';
import { Dispatch, connect } from 'react-redux';
import { searchContractError, setIsLoading, completeContractError } from 'src/contract-error/contract-error.actions';
import { ModalProps } from '@common/components';
import { toggleModal, doAsync } from '@common/components/common.actions';

function mapStateToProps(state: AppState, ownProps: {}): Partial<ContractErrorSearchComponentProperties> {
  return {
    loading: state.contractError.isLoading,
    contractErrorList: state.contractError.contractErrorList,
    pageNumber: state.contractError.pageNumber,
    pageSize: state.contractError.pageSize,
    totalResults: state.contractError.totalResults,
    pageCount: state.contractError.pageCount
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: {}
): Partial<ContractErrorSearchComponentProperties> {
  return {
    setIsLoading: (loading: boolean) => {
      return dispatch(doAsync(setIsLoading(loading)));
    },
    getContractErrorList: (pageNumber: number, pageSize: number, orderBy: string, orderDirection: string) => {
      return dispatch(searchContractError(pageNumber, pageSize, orderBy, orderDirection));
    },
    completeContractError: (contractErrorId: number, completeDate: Date) => {
      return dispatch(completeContractError(contractErrorId, completeDate));
    },
    toggleModal: (modalProps?: ModalProps) => {
      dispatch(toggleModal(modalProps));
    }
  };
}

export const ContractErrorSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractErrorSearchComponent);



// WEBPACK FOOTER //
// ./src/contract-error/_components/contract-error-search/contract-error-search.container.tsx